import { apiUrl } from "../lib/apiBase";

export type ReportBranding = {
  enabled: boolean;
  companyName: string;

  abbreviation?: string;
  useAbbreviation?: boolean;

  tagline?: string;
  phone?: string;
  email?: string;
  website?: string;
  addressLine1?: string;
  addressLine2?: string;

  licenseNumber?: string;

  logoDataUrl?: string; // data:image/png;base64,... (or jpeg)
};

export const REPORT_BRANDING_KEY = "claimsupp:reportBranding:v1";

export function defaultReportBranding(): ReportBranding {
  return {
    enabled: false,
    companyName: "",

    abbreviation: "",
    useAbbreviation: true,

    tagline: "",
    phone: "",
    email: "",
    website: "",
    addressLine1: "",
    addressLine2: "",

    licenseNumber: "",

    logoDataUrl: "",
  };
}

export function loadReportBranding(): ReportBranding {
  try {
    const raw = localStorage.getItem(REPORT_BRANDING_KEY);
    if (!raw) return defaultReportBranding();
    const obj = JSON.parse(raw);
    return { ...defaultReportBranding(), ...(obj || {}) };
  } catch {
    return defaultReportBranding();
  }
}

export function saveReportBranding(b: ReportBranding) {
  localStorage.setItem(REPORT_BRANDING_KEY, JSON.stringify(b));
}

export async function fetchReportBranding(): Promise<ReportBranding | null> {
  try {
    const res = await fetch(apiUrl("/account/branding"), { credentials: "include" });
    const payload = await res.json().catch(() => null);
    if (!res.ok) return null;
    const remote = payload?.branding;
    if (!remote || typeof remote !== "object") return defaultReportBranding();
    return { ...defaultReportBranding(), ...(remote || {}) };
  } catch {
    return null;
  }
}

export async function saveReportBrandingRemote(b: ReportBranding): Promise<void> {
  const res = await fetch(apiUrl("/account/branding"), {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ branding: b }),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => null);
    const message = payload?.error || payload?.message || "Unable to save settings.";
    throw new Error(message);
  }
}
